module.exports = "<nav class=\"navbar navbar-expand-lg navbar-dark fixed-top bg-dark\">\r\n    <a class=\"navbar-brand\" href=\"\">\r\n        <img src=\"assets/sicodatalogo.png\" height=\"32px\" alt=\"SicoDataAS\" />\r\n    </a>\r\n</nav>"


//////////////////
// WEBPACK FOOTER
// C:/pgutev/work/WEBCAM/src/app/shared/app.header.component.html
// module id = ../../../../../src/app/shared/app.header.component.html
// module chunks = main